/**
 * Shared fetch wrapper with auth token from cookies.
 *
 * The legacy session.coffee stores the token in a cookie named "user_token"
 * via $.cookie (js-cookie). We read it directly from document.cookie.
 */
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}
function getApiErrorMessage(text) {
    if (!text) {
        return '';
    }
    try {
        const payload = JSON.parse(text);
        if (payload != null && typeof payload === 'object') {
            const { message, error } = payload;
            if (typeof message === 'string' && message) {
                return message;
            }
            if (typeof error === 'string' && error) {
                return error;
            }
        }
        return '';
    }
    catch (_a) {
        return text;
    }
}
export function isApiError(error) {
    return error instanceof Error && typeof error.status === 'number';
}
export async function apiFetch(url, options = {}) {
    const token = getCookie('user_token');
    const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
    };
    if (token) {
        headers['Authorization'] = `token ${token}`;
    }
    const response = await fetch(url, {
        ...options,
        headers,
    });
    if (!response.ok) {
        const text = await response.text().catch(() => '');
        const message = getApiErrorMessage(text);
        const error = new Error(message || `${response.status} ${response.statusText}`);
        error.status = response.status;
        throw error;
    }
    return response.json();
}
